<template>
  <div class="container-fluid px-0">
    <div class="row content mx-0">
      <div class="col col-md-1 col-xl-1 col-xxl-1 px-0"></div>
      <div class="col-12 col-md-10 col-xl-10 col-xxl-10 px-3 pb-3">
        <div class="row mx-0">
          <div class="col-12 px-0 text-end my-2 mes-update-time">
            <span class="my-0" id="mes-update-time">更新時間:</span>
            <span class="my-0" for="mes-update-time">
              {{ nowTime }}
            </span>
          </div>

          <div class="col-12 px-0 text-start elecBoard-main-title">
            <div>
              <template v-if="tabIndex == 0">裝櫃稼動率</template
              ><template v-else-if="tabIndex == 1">即時資訊</template>-{{
                siteName
              }}
            </div>
          </div>
          <div class="row mx-0 px-0">
            <div
              class="col-12 col-xxl-1 px-0 elecBoard-sub-title order-1 order-xxl-1"
            >
              <div class="my-3">
                {{ operName }}
              </div>
              <div
                v-for="(item, key) in userArray"
                :key="key"
                class="mb-3 elecBoard-oper-img"
              >
                <img
                  :src="item.image"
                  class="mx-auto mb-1"
                  alt="Center image"
                />
                <p class="elecBoard-user-name">
                  {{ item.position + ":" + item.name }}
                </p>
              </div>
            </div>
            <div class="col-12 col-xxl-10 px-0 order-3 order-xxl-2">
              <nav class="px-0">
                <div class="nav nav-tabs mes-tabs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link mes-tab"
                    :class="{ active: tabIndex == 0 }"
                    id="nav-activation-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-activation"
                    type="button"
                    role="tab"
                    aria-controls="nav-activation"
                    aria-selected="false"
                    @click="tabIndex = 0"
                  >
                    裝櫃稼動率
                  </button>
                  <button
                    class="nav-link mes-tab"
                    :class="{ active: tabIndex == 1 }"
                    id="nav-instant-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-instant"
                    type="button"
                    role="tab"
                    aria-controls="nav-instant"
                    aria-selected="true"
                    @click="tabIndex = 1"
                  >
                    即時資訊
                  </button>
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div
                  class="tab-pane fade"
                  :class="{
                    'show active': tabIndex == 0,
                  }"
                  id="nav-activation"
                  role="tabpanel"
                  aria-labelledby="nav-activation-tab"
                >
                  <div class="row mx-0 elecBoard-row">
                    <template v-for="col in 2" :keys="col">
                      <div class="col-12 px-0">
                        <div class="row mx-0">
                          <template v-for="index in colCount" :keys="index">
                            <commonColCard
                              v-if="
                                deviceData[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ]
                              "
                              :colTitleTop="{
                                'elecBoard-col-title-name-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-name-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-name-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-name-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-name-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-name-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-name-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-name-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-name-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                                'elecBoard-col-title-name-I':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'I',
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-status-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-status-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-status-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-status-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-status-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-status-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-status-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-status-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                                'elecBoard-col-title-status-I':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'I',
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].device_name_tw
                                }}</template
                              >
                              <template #col-title-bottom>
                                {{
                                  totalDeviceStatus[
                                    deviceData[
                                      deviceArray[
                                        index - 1 + (col - 1) * colCount
                                      ]
                                    ].status
                                  ].text
                                }}</template
                              >
                              <template #col-title-body>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span
                                        >裝櫃時間:
                                        {{
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].container_time
                                        }}</span
                                      >
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button"
                                        @click="
                                          query_detail(
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ],
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].oper
                                          )
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="
                                        deviceData[
                                          deviceArray[
                                            index - 1 + (col - 1) * colCount
                                          ]
                                        ].stack_bar_information
                                      "
                                      :stacksSize="'package-midle'"
                                    />
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                            <commonColCard
                              v-else-if="
                                deviceArray[index - 1 + (col - 1) * colCount]
                              "
                              :colTitleTop="{
                                'elecBoard-col-title-name-S': true,
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-S': true,
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                }}</template
                              >
                              <template #col-title-bottom>未導入</template>
                              <template #col-title-body>
                                <div class="row mx-0 elecBoard-col-default">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>裝櫃時間:</span>
                                      <span> 0時0分</span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button elecBoard-detail-button-default"
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0 elecBoard-col-default">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="stacksBarDefault"
                                      :stacksSize="'package-midle'"
                                    />
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  :class="{
                    'show active': tabIndex == 1,
                  }"
                  id="nav-instant"
                  role="tabpanel"
                  aria-labelledby="nav-instant-tab"
                >
                  <div class="row mx-0 elecBoard-row">
                    <template v-for="col in 2" :keys="col">
                      <div class="col-12 px-0">
                        <div class="row mx-0">
                          <template v-for="index in colCount" :keys="index">
                            <commonColCard
                              v-if="
                                deviceData[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ]
                              "
                              :colTitleTop="{
                                'elecBoard-col-title-name-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-name-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-name-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-name-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-name-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-name-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-name-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-name-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-name-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                                'elecBoard-col-title-name-I':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'I',
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-status-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-status-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-status-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-status-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-status-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-status-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-status-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-status-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                                'elecBoard-col-title-status-I':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'I',
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].device_name_tw
                                }}</template
                              >
                              <template #col-title-bottom>
                                {{
                                  totalDeviceStatus[
                                    deviceData[
                                      deviceArray[
                                        index - 1 + (col - 1) * colCount
                                      ]
                                    ].status
                                  ].text
                                }}</template
                              >
                              <template #col-title-body class="my-auto">
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>櫃號:</span>
                                      <span>
                                        {{
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].act_ctn_no
                                        }}</span
                                      >
                                    </div>
                                    <div>
                                      <span>客戶名稱:</span>
                                      <span>
                                        {{
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].cuname
                                        }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>總重:</span>
                                      <span>
                                        {{
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].tot_weight.toLocaleString("en-US")
                                        }}KG</span
                                      >
                                    </div>
                                    <div>
                                      <span>車牌:</span>
                                      <span>
                                        {{
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].car_no
                                        }}</span
                                      >
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button"
                                        @click="
                                          query_detail(
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ],
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].oper
                                          )
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>棧板數:</span>
                                      <span>
                                        {{
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].pallet_num
                                        }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                            <commonColCard
                              v-else-if="
                                deviceArray[index - 1 + (col - 1) * colCount]
                              "
                              :colTitleTop="{
                                'elecBoard-col-title-name-S': true,
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-S': true,
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                }}</template
                              >
                              <template #col-title-bottom>未導入</template>
                              <template #col-title-body>
                                <div class="row mx-0 elecBoard-col-default">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>櫃號:</span>
                                      <span>-</span>
                                    </div>
                                    <div>
                                      <span>客戶名稱:</span>
                                      <span>-</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0 elecBoard-col-default">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>總重:</span>
                                      <span>KG</span>
                                    </div>
                                    <div>
                                      <span>車牌: </span>
                                      <span></span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button elecBoard-detail-button-default"
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0 elecBoard-col-default">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>棧板數:</span>
                                      <span></span>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xxl-1 px-0 order-2 order-xxl-3">
              <!-- 即時狀態 -->
              <deviceStatus
                :totalDeviceStatus="totalDeviceStatus"
                :deviceArrayLength="deviceArray.length"
              >
              </deviceStatus>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-md-1 col-xl-1 col-xxl-1 px-0"></div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, inject } from "@vue/runtime-core";
import deviceStatus from "@/components/deviceStatus.vue";
import commonColCard from "@/components/commonColCard.vue";
import stackBar from "@/components/stackBar.vue";
export default {
  components: {
    deviceStatus,
    commonColCard,
    stackBar,
  },
  setup() {
    const store = useStore();

    //getters
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = 43200;
    const stacksBarDefault = computed(
      () => store.getters["stackBar/get_stacksBarDefault"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
    };

    const siteName = inject("siteName");
    const oper = inject("oper");
    const operName = inject("operName");
    const deviceName = inject("deviceName");
    const detail = inject("detail");
    const userArray = inject("userArray");
    const colCount = inject("colCount");
    const deviceArray = inject("deviceArray");
    const totalDeviceStatus = inject("totalDeviceStatus");
    const deviceData = inject("deviceData");
    const tabIndex = inject("tabIndex");

    const nowTime = inject("nowTime");

    const query_detail = (thisDeviceName, thisOper) => {
      console.log(thisDeviceName, thisOper);
      deviceName.value = thisDeviceName;
      oper.value = thisOper;
      detail.value = true;
    };

    return {
      stacksBarClass,
      stacksBarMaxValue,
      stacksBarDefault,
      siteName,
      operName,
      deviceName,
      detail,
      userArray,
      colCount,
      deviceArray,
      totalDeviceStatus,
      deviceData,
      tabIndex,
      nowTime,
      query_detail,
    };
  },
};
</script>

<style scoped>
.elecBoard-row > div:first-child > div .common-col-card:last-child {
  border-bottom: none;
}
</style>
